<template>
  <component :is="params.value.component" v-bind="params.value.props" />
</template>

<script></script>
